module.exports = __webpack_public_path__ + "static/cookie-finder-d43d08df1076a9ffefba15ae536a6b53.jpg";